import { lazy } from 'react';
import { RouteObject } from 'react-router';
import { pagePath } from '../utils/consts/pagePath';

const ChooseTenantPage = lazy(
  () => import('../../view/pages/ChooseTenantPage'),
);
const CreateTenantPage = lazy(
  () => import('../../view/pages/CreateTenantPage'),
);

export const tenantRoutes: RouteObject = {
  path: pagePath.landing,
  children: [
    {
      path: pagePath.tenant.create,
      element: <CreateTenantPage />,
    },
    {
      path: pagePath.tenant.choose,
      element: <ChooseTenantPage />,
    },
  ],
};
